// extracted by mini-css-extract-plugin
module.exports = {"locationContainer":"hotel_location_locationContainer__1A6V3","icon":"hotel_location_icon__2vhQR"};